import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "../ui/button";

type AreYouSureAboutThatProps = {
  title: string;
  description: string;
  yesLabel: string;
  noLabel: string;
  triggerButton: React.ReactNode;
  destructive?: boolean;
  formAction?: (payload: FormData) => void;
  action?: () => void;
};

export const AreYouSureAboutThat = ({
  title,
  description,
  yesLabel,
  noLabel,
  triggerButton,
  destructive = true,
  formAction,
  action,
}: AreYouSureAboutThatProps) => {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{triggerButton}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{noLabel}</AlertDialogCancel>
          {formAction && (
            <form action={formAction}>
              <Button
                type="submit"
                variant={destructive ? "destructive" : "default"}
                asChild
              >
                <AlertDialogAction>{yesLabel}</AlertDialogAction>
              </Button>
            </form>
          )}
          {action && (
            <Button
              onClick={action}
              variant={destructive ? "destructive" : "default"}
              asChild
            >
              <AlertDialogAction>{yesLabel}</AlertDialogAction>
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
